export default "__VITE_ASSET__A9w9gzrV__"